/*
  SVW Reseller Pass, two genuine prices (reseller-hub/golive/pass-addon/PLAN.md, 6 Oct 2026).
  The Pass product has two variants: "On its own" (the price on its own) and "With a stock order" (the add-on price).
  This file keeps the basket on the right one:
    - the basket holds stock (any line that is not the Pass and needs shipping)  -> the Pass is the stock-order variant
    - the basket holds no stock                                                 -> the Pass is the on-its-own variant
  It never changes the stock lines, never removes the Pass, and keeps the Pass quantity as it is (one Pass per order is
  handled by the basket note and terms 5.4). Discounts on the stock lines (Bundle & Save, sales, codes) are untouched,
  because the Pass price is a variant price, not a discount.

  It runs: on page load when the basket already holds the Pass (Liquid tells it), after every cart change published on
  PUB_SUB_EVENTS.cartUpdate, when the tab comes back (Back button, another tab), and as a last check when Check out is
  pressed while a change is still pending. Anything it cannot fix (JavaScript off, a cart link straight to checkout)
  is caught after payment by the Flow back-stop in PLAN.md.

  Config: <script type="application/json" id="svw-pass-addon-cfg"> from snippets/svw-pass-addon.liquid.
  plan() is pure and is unit tested in reseller-hub/golive/pass-addon/test_plan.cjs (node).
*/
(function (root) {
  'use strict';

  function isPassLine(item, cfg) {
    return item.product_id === cfg.pid || item.variant_id === cfg.own || item.variant_id === cfg.addon;
  }

  function hasProps(item) {
    var p = item.properties;
    if (!p) return false;
    return Object.keys(p).some(function (k) {
      return p[k] !== null && p[k] !== '';
    });
  }

  // cart: the /cart.js shape (items[].key, variant_id, product_id, quantity, requires_shipping, properties).
  // cfg: { pid, own, addon } numbers.
  // Returns { action: 'none' | 'swap', reason, stock, target, qty, updates, add }.
  //   updates: the /cart/update.js "updates" object (line keys as strings, or the target variant id) in one request.
  //   add: the /cart/add.js fallback ({ id, quantity, properties }) when the target line has to be added separately.
  function plan(cart, cfg) {
    var items = (cart && cart.items) || [];
    var pass = items.filter(function (i) { return isPassLine(i, cfg); });
    if (!pass.length) return { action: 'none', reason: 'no-pass' };
    var stock = items.some(function (i) { return !isPassLine(i, cfg) && i.requires_shipping === true; });
    var target = stock ? cfg.addon : cfg.own;
    var qty = pass.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
    if (pass.length === 1 && pass[0].variant_id === target) {
      return { action: 'none', reason: 'ok', stock: stock, target: target, qty: qty };
    }
    var keep = null;
    for (var n = 0; n < pass.length; n++) {
      if (pass[n].variant_id === target && !hasProps(pass[n])) { keep = pass[n]; break; }
    }
    var updates = {};
    pass.forEach(function (i) { if (i !== keep) updates[String(i.key)] = 0; });
    var add = null;
    if (keep) {
      updates[String(keep.key)] = qty;
    } else {
      var src = pass[0];
      add = { id: target, quantity: qty };
      if (hasProps(src)) add.properties = src.properties;
      else updates[String(target)] = qty;
    }
    return {
      action: 'swap',
      reason: pass.length > 1 ? 'merge' : stock ? 'to-addon' : 'to-own',
      stock: stock, target: target, qty: qty, updates: updates, add: add,
    };
  }

  var api = { plan: plan, isPassLine: isPassLine };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.SvwPassAddon && window.SvwPassAddon.started) return;
  window.SvwPassAddon = api;

  var cfgEl = document.getElementById('svw-pass-addon-cfg');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.on || !cfg.pid || !cfg.own || !cfg.addon || cfg.own === cfg.addon) return;
  api.started = true;
  api.cfg = cfg;

  var R = window.routes || {};
  var CART_JS = (R.cart_url || '/cart') + '.js';
  var UPDATE_JS = (R.cart_update_url || '/cart/update') + '.js';
  var ADD_JS = (R.cart_add_url || '/cart/add') + '.js';
  var SRC = 'svw-pass-addon';

  var knownPass = !!cfg.hasPass;   // the basket held the Pass when this page was rendered
  var dirty = knownPass;           // a check is owed before checkout
  var running = null;
  var again = false;
  var tries = {};                  // per planned change, so a refused change is not retried forever
  var timer = null;
  var bypass = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }
  function getCart() {
    return fetch(CART_JS, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function refreshUi(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SRC, cartData: cart });
    }
    document.dispatchEvent(new CustomEvent('svw:pass-addon:swapped', { detail: { cart: cart } }));
  }

  // One pass: read the cart, fix it if needed, read it back. Resolves true when it changed the cart.
  function once() {
    return getCart().then(function (cart) {
      var p = plan(cart, cfg);
      knownPass = p.reason !== 'no-pass';
      if (p.action === 'none') return false;
      var sig = JSON.stringify([p.updates, p.add]);
      tries[sig] = (tries[sig] || 0) + 1;
      if (tries[sig] > 2) {
        if (window.console) console.warn('[svw-pass-addon] gave up on', p.reason, p.updates);
        return false;
      }
      var step = p.add
        ? post(ADD_JS, { items: [p.add] }).then(function () {
            var rm = {};
            Object.keys(p.updates).forEach(function (k) { if (p.updates[k] === 0) rm[k] = 0; });
            return post(UPDATE_JS, { updates: rm });
          })
        : post(UPDATE_JS, { updates: p.updates });
      return step
        .then(getCart)
        .then(function (after) {
          var q = plan(after, cfg);
          if (q.action !== 'none' && !p.add) {
            // the single request did not land as planned: try the two-step route once
            var rm = {};
            Object.keys(q.updates || {}).forEach(function (k) { if (q.updates[k] === 0) rm[k] = 0; });
            var target = q.add || { id: q.target, quantity: q.qty };
            var hasTarget = (after.items || []).some(function (i) { return i.variant_id === q.target; });
            var chain = hasTarget ? post(UPDATE_JS, { updates: q.updates }) : post(ADD_JS, { items: [target] }).then(function () { return post(UPDATE_JS, { updates: rm }); });
            return chain.then(getCart);
          }
          return after;
        })
        .then(function (final) {
          refreshUi(final);
          return true;
        });
    });
  }

  function reconcile() {
    if (running) { again = true; return running; }
    var changed = false;
    running = (function loop() {
      again = false;
      return once().then(function (c) {
        changed = changed || c;
        if (again) return loop();
      });
    })()
      .catch(function (e) { if (window.console) console.error('[svw-pass-addon]', e); })
      .then(function () {
        running = null;
        dirty = false;
        return changed;
      });
    return running;
  }

  function soon(ms) {
    dirty = true;
    clearTimeout(timer);
    timer = setTimeout(reconcile, ms || 150);
  }

  // Does this cart event need a look? Skip only a plain stock add to a basket that has never held the Pass.
  function needsLook(ev) {
    var d = ev && ev.cartData;
    if (d && Array.isArray(d.items)) {
      var p = plan(d, cfg);
      knownPass = p.reason !== 'no-pass';
      return p.action !== 'none';
    }
    if (d && (d.product_id === cfg.pid || d.variant_id === cfg.own || d.variant_id === cfg.addon)) return true;
    if (ev && (ev.productVariantId == cfg.own || ev.productVariantId == cfg.addon)) return true;
    if (d && d.product_id && !knownPass) return false;
    return true;
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === SRC) return;
        if (needsLook(ev)) soon(150);
      });
    }
    if (knownPass) soon(0);
    window.addEventListener('pageshow', function (e) { if (e.persisted && knownPass) soon(0); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && knownPass) soon(300);
    });
  }

  // Last check at Check out, only while a change is pending or running (the normal path is not touched).
  document.addEventListener(
    'submit',
    function (e) {
      if (bypass) return;
      var form = e.target;
      var btn = e.submitter;
      if (!form || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;
      if (!btn || btn.name !== 'checkout') return;
      if (!knownPass || (!dirty && !running)) return;
      e.preventDefault();
      clearTimeout(timer);
      var go = function () {
        bypass = true;
        try {
          if (form.requestSubmit) form.requestSubmit(btn);
          else form.submit();
        } finally {
          bypass = false;
        }
      };
      reconcile().then(
        function (changed) {
          if (!changed) return go();
          // The basket was just changed: the form's quantities are posted by position, so do not post this form.
          // Show the new basket and ask for the tick again (the re-render clears it).
          var msg =
            'Your basket has been updated, so the Reseller Pass now shows the right price for this order. Please check it, tick the box and press Check out again.';
          // The refresh replaces the drawer footer a moment later, so the message is written again after it.
          [0, 700, 1600].forEach(function (ms) {
            setTimeout(function () {
              var el = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
              if (el && el.textContent !== msg) {
                el.textContent = msg;
                el.setAttribute('role', 'alert');
              }
            }, ms);
          });
        },
        function () { go(); }
      );
    },
    true
  );

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(this);
